import { rem, rgba } from 'polished';
import * as React from 'react';
import styled from 'styled-components';
import { IconType, SvgIcon } from '../General/SvgIcon';
import { CategoryFilterCheckboxes } from './CategoryFilterCheckboxes';

interface Props {
  filters: any;
  handleCheckboxChange: any;
  isB2B: any;
  name: string;
  checkboxes: any;
}

export function CategoryFilterCheckboxesGroup({
  filters,
  handleCheckboxChange,
  isB2B,
  name,
  checkboxes,
}: Props) {
  const [isOpened, setIsOpened] = React.useState(true);

  const toggleIsOpened = () => {
    setIsOpened(!isOpened);
  };

  return (
    <Wrapper>
      <MobileCheckboxesWrapper>
        <TitleWrapper onClick={toggleIsOpened}>
          <Title>{name}</Title>
          <SvgIcon
            icon={
              isOpened ? IconType.chevronUpSmall : IconType.chevronDownSmall
            }
            width={16}
            height={16}
            viewBox="0 0 16 16"
          />
        </TitleWrapper>
        {isOpened && (
          <CheckboxesWrapper>
            {checkboxes.map((item, index) => {
              return (
                <CheckboxWrapper key={index}>
                  <CategoryFilterCheckboxes
                    filters={filters}
                    handleCheckboxChange={handleCheckboxChange}
                    isB2B={isB2B}
                    label={item.label}
                    marginRight={0}
                    marginLeft={0}
                  />
                </CheckboxWrapper>
              );
            })}
          </CheckboxesWrapper>
        )}
      </MobileCheckboxesWrapper>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  background: ${({ theme }) => rgba(theme.colors.primary, 0.12)};
  border-radius: ${rem(4)};
  padding: ${rem(32)} ${rem(24)};
  margin-bottom: ${rem(7)};

  ${({ theme }) => theme.mediab.l925`
    margin-bottom: 0;
    border-bottom: ${rem(2)} solid #EEEEEE;
    background: ${theme.colors.white};
    border-radius: 0;
  `}
`;

const MobileCheckboxesWrapper = styled.div`
  /* border-bottom: ${rem(2)} solid #EEEEEE; */
`;

const CheckboxesWrapper = styled.div`
  margin-top: ${rem(32)};
  max-height: ${rem(165)};
  overflow: scroll;
  overflow-x: hidden;

  ::-webkit-scrollbar {
    width: ${rem(4)};
  }
  ::-webkit-scrollbar-track {
    background: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.primary};
    border-radius: ${rem(2)};
  }

  ${({ theme }) => theme.mediab.l925`
    ::-webkit-scrollbar-thumb {
      background: #EEEEEE;
    }
  `}
`;

const CheckboxWrapper = styled.div`
  margin-bottom: ${rem(16)};
`;

const TitleWrapper = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${({ theme }) => theme.mediab.l925`
    svg {
      fill: ${theme.colors.black};
    }
  `}
`;

const Title = styled.h4`
  font-size: ${rem(16)};
  line-height: ${rem(24)};
  font-weight: 500;
  color: ${({ theme }) => theme.colors.textPrimary};
  margin: 0;
`;
